// src/api.js
import axios from 'axios';

// Używaj zmiennej środowiskowej
const API_URL = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:3004"; 


export const login = (username, password) => {
  return axios.post(`${API_URL}/auth/login`, { username, password });
};

export const checkVoucher = (token, input) => {
  const params = {};
  if (input.startsWith('BOHO-')) {
    params.code = input;
  } else {
    params.qrData = input;
  }

  return axios.get(`${API_URL}/vouchers/check`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });
};

export const redeemVoucher = (token, voucherId, amount = null) => {
  const data = { voucherId };
  if (amount !== null && amount !== undefined) {
    data.amount = amount;
  }
  return axios.post(`${API_URL}/vouchers/use`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const reactivateVoucher = (token, voucherId, newValidUntil = null, newAmount = null) => {
  const data = { voucherId };
  if (newValidUntil) {
    data.newValidUntil = newValidUntil;
  }
  if (newAmount !== null && newAmount !== undefined) {
    data.newAmount = newAmount;
  }
  return axios.post(`${API_URL}/vouchers/reactivate`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const fetchSystemLogs = (token, params = {}) => {
  return axios.get(`${API_URL}/system-logs`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });
};

export const fetchSystemLogTimeline = (token, correlationId) => {
  return axios.get(`${API_URL}/system-logs/timeline`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { correlationId }
  });
};
